import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Reporting day", { props: { triggerType: "Scheduled", event: "1st of the month, 09:00" } }],
  ["e1", "auto-email", "Your monthly report", { props: { subject: "{{contact.company}} — {{month}} results" } }],
  ["w1", "auto-wait", "Wait 3 days", { props: { duration: "3", unit: "days" } }],
  ["c1", "auto-condition", "Opened the report?", { props: { condition: "Opened 'Your monthly report'" } }],
  ["k1", "auto-task", "Call the clients who didn't open", { props: { assignee: "Account manager", due: "+2 days" } }],
  ["w2", "auto-wait", "Wait 2 weeks", { props: { duration: "2", unit: "weeks" } }],
  ["e2", "auto-email", "Quarterly review — book 30 minutes", { props: { subject: "Time for a proper look at the numbers" } }],
  ["c2", "auto-condition", "Silent for 60 days?", { props: { condition: "last_reply_days is greater than 60" } }],
  ["nt", "auto-notify", "Churn risk alert", { props: { channel: "email", message: "At risk: {{contact.company}} — no contact in 60 days" } }],
  ["tg", "auto-tag-add", "Tag: at-risk", { props: { tag: "at-risk" } }],
]);

const def: TemplateDef = {
  slug: "agency-retention-reporting",
  name: "Client Retention & Reporting",
  category: "Agency",
  tagline:
    "Report monthly, notice the silence, and book the QBR before the client drafts the email.",
  description:
    "A free agency retention template: a scheduled monthly report goes out, an opened? branch flags the clients who ignored it, a quarterly review invite follows, and 60 days of silence raises a churn-risk alert. Clone it into FrazzleCRM and make retention a process instead of a hunch.",
  whatsInside: [
    "Scheduled monthly reporting trigger — the same date, every client",
    "Opened? branch that turns an unread report into a phone call",
    "Quarterly review invite on a fortnight's delay",
    "60-day silence detector with an internal alert and an at-risk tag",
  ],
  flow: makeFlow(
    [
      node("rp", "prov-google", "Report (Sheets / Looker)", 40, 60),
      node("wk", "prov-slack", "Client Slack", 40, 240),
      flow("f1", "Retention Rhythm", 360, 40, 420, 1040),
      ...seq.nodes,
      node("bk", "page-booking", "Quarterly review", 880, 260, { props: { duration: "30 min" } }),
      node("out", "outcome-won", "Retainer renewed", 1200, 260, { props: { value: "$4,000/mo" } }),
      node("n1", "util-note", "Silence is the churn signal", 40, 440, {
        notes:
          "Clients rarely announce that they are leaving — they stop replying first. A 60-day silence rule catches it while there is still a conversation to have.",
      }),
    ],
    [
      edge("rp", "f1"),
      edge("wk", "f1"),
      ...seq.edges,
      edge("f1", "bk"),
      edge("bk", "out"),
    ]
  ),
};

export default def;
